import React, { useState, useContext } from 'react';
import { Typography, Grid, FormControl, FormControlLabel, Checkbox, Button, CircularProgress } from '@material-ui/core';
import { useStateValue } from 'context/store';
import { returnToOriginAction, confirmReturnToOriginAction } from 'context/booking/actions';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { convertToKm, formatCostTemporal, modalMessage } from 'utils';
import { I18nContext } from 'translations';

export default function ToggleReturnToOrigin ({ booking, history }) {
  const { translate } = useContext(I18nContext);
  const [, dispatch] = useStateValue();
  const [isReturnToOrigin, setIsReturnToOrigin] = useState(false);
  const [loadingQuoteReturn, setLoadingQuoteReturn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [quoteReturn, setQuoteReturn] = useState();
  const isToken = localStorage.getItem('session_token');

  const quoteData = async (quote) => {
    setQuoteReturn(quote);
    setLoadingQuoteReturn(false)
  }

  const submit = async (isReturn) => {
    if (isToken) {
      setIsReturnToOrigin(isReturn)
      setLoadingQuoteReturn(true);
      const callback = await returnToOriginAction(
        booking?._id,
        isToken,
        dispatch
      );
      callback.info ? quoteData(callback?.info) : setLoadingQuoteReturn(false);
    } else {
      messageLogin()
    }
  }

  const messageLogin = () => {
    modalMessage(
      '',
      translate('app.booking.loginFirstToPerformThisAction'),
      'info',
      translate('app.booking.logIn'),
      true,
      true,
      translate('cancel')
    ).then((response) => {
      if (response.value) {
        history.push({
          pathname: '/login',
          search: `?id=${booking._id}`,
        });
      }
    });
  };

  const confirmReturnToOrigin = async () => {
    if (isToken) {
      modalMessage(
        '',
        translate('app.booking.addRountTrip.confirmReturnText'),
        '',
        translate('accept'),
        true,
        true,
        translate('cancel')
      ).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true);
          const callback = await confirmReturnToOriginAction(
            booking?._id,
            isToken,
            dispatch
          );
          callback && setLoading(false)
        }
      });
    } else {
      messageLogin();
    }
  }

  return (
    <Grid container alignItems="center" className="booking-data booking-stops">
      <Grid item xs={12}>
        <FormControl style={{ marginBottom: 10 }}>
          <FormControlLabel
            control={
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="return_to_origin"
                checked={isReturnToOrigin}
                onChange={e => submit(e.target.checked)}
                disabled={loadingQuoteReturn}
              />
            }
            label={<Typography color='primary'>{translate('app.booking.addRoundTrip')}</Typography>}
          />
        </FormControl>
        <Typography variant="body2" color="textSecondary" style={{ display: 'block' }}>
          {translate('app.booking.addRoundTrip.description')}
        </Typography>
        <hr style={{ background: '#ededed', height: '3px', border: 0 }}/>
        {quoteReturn &&
          <>
            <Typography variant="body2" color="textSecondary" style={{ display: 'block' }}>
              <b>{translate('app.booking.addRoundTrip.additionalkm')}: </b> {quoteReturn.distance_difference ? convertToKm(quoteReturn.distance_difference) : '-'}
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ display: 'block' }}>
              <b>{translate('app.booking.addRoundTrip.AdditionalRange')}: </b> {quoteReturn.price_difference ? formatCostTemporal(quoteReturn.price_difference) : '-'}
            </Typography>
            <div style={{ padding: '18px 15px 10px'}}>
              <Button
                variant="contained"
                color="default"
                type="button"
                style={{ marginRight: '15px'}}
                disabled={loading}
                onClick={() => {
                  setQuoteReturn(false)
                  setIsReturnToOrigin(false)
                }}
              >
                {translate('cancel')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="button"
                onClick={confirmReturnToOrigin}
                disabled={loading}
                startIcon={loading && <CircularProgress size={18} color="inherit" />}
              >
                {translate('app.express.confirm')}
              </Button>
            </div>
          </>
        }
      </Grid>
    </Grid>
  )
}